import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

export default createRouter({
  routeTree, context: {
    // auth will initially be undefined
    // We'll be passing down the auth state from within a React component
    auth: undefined,
  },
});
